var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"color":"primary"}},[_c('v-list-item-avatar',{staticClass:"d-block mx-auto",attrs:{"height":"90px","width":"90px"}},[_c('v-img',{attrs:{"src":_vm.avatar}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }